// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "global." + {"87":"5952ea1f477732e2f924","301":"fbfc98f08953d1b490f0"}[chunkId] + ".js";
};